import   axios  from 'axios';

import { BackendResponse ,
         handleError     }  from '../../dataTypes/backendServicesManagment/types';

import { API_URLS        }  from '../urls';

// Détail grossier de l'espace disque d'un créateur (mini-fenêtre « Stockage » de l'en-tête).
// Les rubriques somment `measuredBytes`, la taille de creators/<uuid>/ — la même
// définition que quotaUsed, qui n'en diffère que par une dérive pas encore recalculée.

export interface StorageBreakdownItem
 {
  key   : string ;
  label : string ;
  bytes : number ;
  files : number ;
 }

export interface StorageBreakdown
 {
  measuredBytes : number                 ;
  quotaUsed     : number                 ;
  quotaDisk     : number                 ;
  items         : StorageBreakdownItem[] ;
 }

export const getAdminStorageBreakdown = async ( adminId: number ): Promise<BackendResponse<StorageBreakdown | null>> => {

  const url = API_URLS.getAdminStorageBreakdown.replace ( '{id}' , `${adminId}` );

  try
   {
    const response = await axios.get ( url );

    if ( response.status === 200 ) { return { code: 1 , comment: '' , payload: response.data as StorageBreakdown }; }

    return handleError ( -102 , `Réponse inattendue : ${response.status}` , null );
   }
  catch ( error )
   {
    console.warn ( 'getAdminStorageBreakdown' , url , error );

    return handleError ( -101 , String ( error ) , null );
   }
};
